const eventListenerFactory = require('@ordergroove/brandy/src/app/core/directives/event.listener.factory');

module.exports = angular.module('msi.quantity', [
  require('@ordergroove/brandy/src/app/subscriptions/service'),
  require('@ordergroove/brandy/src/app/items'),
  require('@ordergroove/brandy/src/app/core/constants'),
  require('@ordergroove/brandy/src/app/toasts'),
  require('./quantity-control.controller').module
]).name;

angular.module(module.exports)
  .component('ogQuantityControl', require('./quantity-control'))
  .directive('ogOnQuantityChange', eventListenerFactory('ogOnQuantityChange'))
  .provider('quantityControl', require('./quantity-control.provider'));
